<!-- Header + Filters -->
<div class="flex flex-col w-full" [formGroup]="filtersForm">
  <div class="flex justify-center mb-4">
    <mat-button-toggle-group
      [(ngModel)]="reportMode"
      [ngModelOptions]="{ standalone: true }"
      (change)="onModeChange()"
    >
      <mat-button-toggle value="quarterly">Quarterly</mat-button-toggle>
      <mat-button-toggle value="monthly">Monthly</mat-button-toggle>
    </mat-button-toggle-group>
  </div>

  <div class="flex flex-row justify-between items-center">
    <div>
      <div class="flex items-end w-full">
        <h1 class="learner pr-2">{{ reportMode === 'quarterly' ? 'Quarterly' : 'Monthly' }} Report</h1>
        <div>
          <button class="primary-link ml-4" (click)="downloadReport()" [disabled]="disableExport">
            <svg
              [class.disabled-icon]="disableExport"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 512 512"
            >
              <path
                d="M280 24c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 270.1-95-95c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9L239 369c9.4 9.4 24.6 9.4 33.9 0L409 233c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-95 95L280 24zM128.8 304L64 304c-35.3 0-64 28.7-64 64l0 80c0 35.3 28.7 64 64 64l384 0c35.3 0 64-28.7 64-64l0-80c0-35.3-28.7-64-64-64l-64.8 0-48 48L448 352c8.8 0 16 7.2 16 16l0 80c0 8.8-7.2 16-16 16L64 464c-8.8 0-16-7.2-16-16l0-80c0-8.8 7.2-16 16-16l112.8 0-48-48zM432 408a24 24 0 1 0 -48 0 24 24 0 1 0 48 0z"
              />
            </svg>
            Export
          </button>
        </div>
      </div>

      <div class="mt-3">
        <h2 class="learner">
          {{ reportingPeriod }}
          @if (currentState != '') {
            <span>- State of</span>
          }
          {{ currentState }}
        </h2>
      </div>
    </div>

    <div class="flex flex-col flex-wrap">
      <div class="flex flex-row flex-wrap">
        <div class="w-full" [class]="reportMode === 'monthly' ? 'lg:w-1/4' : 'lg:w-1/2'" [style.display]="lookupsStore.statesSignal().length <= 1 ? 'none' : ''">
          <mat-form-field class="w-full pr-4">
            <mat-label>State</mat-label>
            <mat-select formControlName="state" panelClass="mat-select-mt3">
              <mat-option value="">All</mat-option>
              @for (state of lookupsStore.statesSignal(); track $index) {
                <mat-option [value]="state['text']">{{ state.label }} </mat-option>
              }
            </mat-select>
          </mat-form-field>
        </div>

        @if (reportMode === 'quarterly') {
          <div class="w-full" [class]="lookupsStore.statesSignal().length > 1 ? 'lg:w-1/2' : ''">
            <mat-form-field class="w-full pr-4">
              <mat-label>Report Period</mat-label>
              <mat-select formControlName="yearQuarter" panelClass="mat-select-mt3">
                @for (yearQuarter of yearQuarters; track yearQuarter) {
                  <mat-option [value]="yearQuarter.value">{{ yearQuarter.label }} </mat-option>
                }
              </mat-select>
            </mat-form-field>
          </div>
        }

        @if (reportMode === 'monthly') {
          <div
            class="flex flex-row gap-4 w-full"
            [class]="lookupsStore.statesSignal().length > 1 ? 'lg:w-3/4' : ''"
          >
            <div class="flex flex-col" style="min-width: 120px;">
              <mat-form-field class="w-full">
                <mat-label>From Month</mat-label>
                <mat-select formControlName="fromMonth" panelClass="mat-select-mt3">
                  @for (m of months; track m) {
                    <mat-option [value]="m.value">{{ m.label }}</mat-option>
                  }
                </mat-select>
              </mat-form-field>
              <mat-form-field class="w-full">
                <mat-label>From Year</mat-label>
                <mat-select formControlName="fromYear" panelClass="mat-select-mt3">
                  @for (y of years; track y) {
                    <mat-option [value]="y">{{ y }}</mat-option>
                  }
                </mat-select>
              </mat-form-field>
            </div>
            <div class="flex flex-col" style="min-width: 120px;">
              <mat-form-field class="w-full">
                <mat-label>To Month</mat-label>
                <mat-select formControlName="toMonth" panelClass="mat-select-mt3">
                  @for (m of months; track m) {
                    <mat-option [value]="m.value">{{ m.label }}</mat-option>
                  }
                </mat-select>
              </mat-form-field>
              <mat-form-field class="w-full">
                <mat-label>To Year</mat-label>
                <mat-select formControlName="toYear" panelClass="mat-select-mt3">
                  @for (y of years; track y) {
                    <mat-option [value]="y">{{ y }}</mat-option>
                  }
                </mat-select>
              </mat-form-field>
            </div>
          </div>
        }
      </div>
    </div>
  </div>
</div>

<!-- Completed Trainings Pie Chart -->
<div class="dashboard mt-8">
  <div class="left-column">
    <div class="card">
      <h2 class="learner text-center">Completed Trainings</h2>
      <div class="chart-container" style="min-height: 350px;">
        @if (chartSeries.length > 0) {
          <apx-chart
            class="pie-chart"
            [series]="chartSeries"
            [chart]="pieChartOptions.chart"
            [labels]="pieChartOptions.labels"
            [colors]="pieChartOptions.colors"
          ></apx-chart>
        }
      </div>
    </div>
  </div>
</div>

<!-- Training Metrics -->
<div class="section-row mt-8">
  <div class="section-header">
    <h2 class="learner">Training Metrics</h2>
  </div>
  <div class="chart-stats-row">
    <div class="chart-area">
      @if (trainingMetricsChart.series) {
        <apx-chart
          [series]="trainingMetricsChart.series"
          [chart]="trainingMetricsChart.chart"
          [dataLabels]="trainingMetricsChart.dataLabels"
          [plotOptions]="trainingMetricsChart.plotOptions"
          [stroke]="trainingMetricsChart.stroke"
          [xaxis]="trainingMetricsChart.xaxis"
          [yaxis]="trainingMetricsChart.yaxis"
          [colors]="trainingMetricsChart.colors"
          [tooltip]="trainingMetricsChart.tooltip"
          [legend]="trainingMetricsChart.legend"
        ></apx-chart>
      }
    </div>
    <div class="stats-area">
      <div class="stat-card">
        <h3 class="stat-title">Course Registrations</h3>
        <span class="stat-number">{{
          (quarterlyReportsStore.quarterCourseRegistrationSignal()
            ? quarterlyReportsStore.quarterCourseRegistrationSignal().tally
            : null
          ) | number
        }}</span>
        <span class="stat-alltime">All Time Total - {{
          (quarterlyReportsStore.totalCourseRegistrationSignal()
            ? quarterlyReportsStore.totalCourseRegistrationSignal().tally
            : null
          ) | number
        }}</span>
      </div>
      <div class="stat-card">
        <h3 class="stat-title">Certificates Issued</h3>
        <span class="stat-number">{{
          (quarterlyReportsStore.quarterCourseCertificateSignal()
            ? quarterlyReportsStore.quarterCourseCertificateSignal().tally
            : null
          ) | number
        }}</span>
        <span class="stat-alltime">All Time Total - {{
          (quarterlyReportsStore.totalCourseCertificateSignal()
            ? quarterlyReportsStore.totalCourseCertificateSignal().tally
            : null
          ) | number
        }}</span>
      </div>
      <div class="text-left mt-2">
        <a routerLink="/report/training" class="primary-link">View Training Reports</a>
      </div>
    </div>
  </div>
</div>

<!-- Course Detail by Month -->
<div class="section-row mt-8">
  <div class="section-header">
    <h2 class="learner">Course Detail by Month</h2>
  </div>

  <div class="grid-container mt-4">
    <section>
      <h2 class="learner">Course Registrations</h2>
      <table class="data-table">
        <thead>
          <tr>
            <th>Course</th>
            <th>Language</th>
            <th>Refresher</th>
            @for (m of detailMonths; track m.key) {
              <th>{{ m.label }}</th>
            }
            <th>Total</th>
          </tr>
        </thead>
        <tbody>
          @for (row of registrationDetailRows; track row) {
            <tr>
              <td>{{ row.learningPath }}</td>
              <td>{{ row.language }}</td>
              <td>{{ row.isRefresher ? 'Yes' : 'No' }}</td>
              @for (m of detailMonths; track m.key) {
                <td>{{ (row.counts[m.key] || 0) | number }}</td>
              }
              <td>{{ row.total | number }}</td>
            </tr>
          }
          @if (registrationDetailRows.length === 0) {
            <tr>
              <td [attr.colspan]="detailMonths.length + 4">No data for the selected period.</td>
            </tr>
          }
        </tbody>
      </table>
    </section>
  </div>

  <div class="grid-container mt-4">
    <section>
      <h2 class="learner">Course Completions</h2>
      <table class="data-table">
        <thead>
          <tr>
            <th>Course</th>
            <th>Language</th>
            <th>Refresher</th>
            @for (m of detailMonths; track m.key) {
              <th>{{ m.label }}</th>
            }
            <th>Total</th>
          </tr>
        </thead>
        <tbody>
          @for (row of completionDetailRows; track row) {
            <tr>
              <td>{{ row.learningPath }}</td>
              <td>{{ row.language }}</td>
              <td>{{ row.isRefresher ? 'Yes' : 'No' }}</td>
              @for (m of detailMonths; track m.key) {
                <td>{{ (row.counts[m.key] || 0) | number }}</td>
              }
              <td>{{ row.total | number }}</td>
            </tr>
          }
          @if (completionDetailRows.length === 0) {
            <tr>
              <td [attr.colspan]="detailMonths.length + 4">No data for the selected period.</td>
            </tr>
          }
        </tbody>
      </table>
    </section>
  </div>
</div>

<!-- Account Metrics -->
<div class="section-row mt-8">
  <div class="section-header">
    <h2 class="learner">Account Metrics</h2>
  </div>
  <div class="chart-stats-row">
    <div class="chart-area">
      @if (accountMetricsChart.series) {
        <apx-chart
          [series]="accountMetricsChart.series"
          [chart]="accountMetricsChart.chart"
          [dataLabels]="accountMetricsChart.dataLabels"
          [plotOptions]="accountMetricsChart.plotOptions"
          [stroke]="accountMetricsChart.stroke"
          [xaxis]="accountMetricsChart.xaxis"
          [yaxis]="accountMetricsChart.yaxis"
          [colors]="accountMetricsChart.colors"
          [tooltip]="accountMetricsChart.tooltip"
          [legend]="accountMetricsChart.legend"
        ></apx-chart>
      }
    </div>
    <div class="stats-area">
      <div class="stat-card">
        <h3 class="stat-title">User Registrations</h3>
        <span class="stat-number">{{ quarterlyReportsStore.accountMetricsSignal()?.periodUserRegistrations | number }}</span>
        <span class="stat-alltime">All Time Total - {{ quarterlyReportsStore.accountMetricsSignal()?.allTimeUserRegistrations | number }}</span>
      </div>
      <div class="stat-card">
        <h3 class="stat-title">Org Registrations</h3>
        <span class="stat-number">{{ quarterlyReportsStore.accountMetricsSignal()?.periodOrgRegistrations | number }}</span>
        <span class="stat-alltime">All Time Total - {{ quarterlyReportsStore.accountMetricsSignal()?.allTimeOrgRegistrations | number }}</span>
      </div>
      <div class="text-left mt-2">
        <a routerLink="/report/learner" class="primary-link">View Learner Reports</a>
      </div>
    </div>
  </div>
</div>

<!-- Website Analytics -->
<div class="section-row mt-8">
  <div class="section-header">
    <h2 class="learner">Website Analytics</h2>
  </div>
  <div class="chart-stats-row">
    <div class="chart-area">
      @if (websiteAnalyticsChart.series) {
        <apx-chart
          [series]="websiteAnalyticsChart.series"
          [chart]="websiteAnalyticsChart.chart"
          [dataLabels]="websiteAnalyticsChart.dataLabels"
          [plotOptions]="websiteAnalyticsChart.plotOptions"
          [stroke]="websiteAnalyticsChart.stroke"
          [xaxis]="websiteAnalyticsChart.xaxis"
          [yaxis]="websiteAnalyticsChart.yaxis"
          [colors]="websiteAnalyticsChart.colors"
          [tooltip]="websiteAnalyticsChart.tooltip"
          [legend]="websiteAnalyticsChart.legend"
        ></apx-chart>
      }
    </div>
    <div class="stats-area">
      <div class="stat-card">
        <h3 class="stat-title">Users</h3>
        <span class="stat-number">{{ quarterlyReportsStore.websiteAnalyticsSignal()?.periodUsers | number }}</span>
        <span class="stat-alltime">All Time Total - {{ quarterlyReportsStore.websiteAnalyticsSignal()?.allTimeUsers | number }}</span>
      </div>
      <div class="stat-card">
        <h3 class="stat-title">Sessions</h3>
        <span class="stat-number">{{ quarterlyReportsStore.websiteAnalyticsSignal()?.periodSessions | number }}</span>
        <span class="stat-alltime">All Time Total - {{ quarterlyReportsStore.websiteAnalyticsSignal()?.allTimeSessions | number }}</span>
      </div>
    </div>
  </div>
</div>

<!-- Statistics by Org -->
<div class="section-row mt-8">
  <div class="section-header">
    <h2 class="learner">Statistics by Org</h2>
  </div>

  <!-- Org Category Pie Chart -->
  @if (orgCategoryPieSeries.length > 0) {
    <div class="dashboard mt-4">
      <div class="left-column">
        <div class="card">
          <h2 class="learner text-center">Organizational Totals by Category</h2>
          <div class="chart-container" style="min-height: 350px;">
            <apx-chart
              class="pie-chart"
              [series]="orgCategoryPieSeries"
              [chart]="orgCategoryPieChart.chart"
              [labels]="orgCategoryPieChart.labels"
              [colors]="orgCategoryPieChart.colors"
            ></apx-chart>
          </div>
        </div>
      </div>
    </div>
  }

  <!-- Top Performing Organizations -->
  <div class="grid-container mt-4">
    <section>
      <h2 class="learner">Top Performing Organizations</h2>
      <table class="data-table">
        <thead>
          <tr>
            <th>Org Name</th>
            <th>Category</th>
            <th>Create Date</th>
            <th>Total Registered Users</th>
            <th>Total Course Registrations</th>
            <th>Total Certificates</th>
          </tr>
        </thead>
        <tbody>
          @for (org of this.quarterlyReportsStore.topOrganizationsSignal(); track org) {
            <tr>
              <td>{{ org.description1.name }}</td>
              <td>{{ org.description1.description }}</td>
              <td>{{ org.description2?.name }}</td>
              <td>{{ org.count1.total | number }}</td>
              <td>{{ org.count2.total | number }}</td>
              <td>{{ org.count3.total | number }}</td>
            </tr>
          }
        </tbody>
      </table>
      <div class="text-left pl-6 mt-2">
        <a routerLink="/organization" class="primary-link">View Organizations</a>
      </div>
    </section>
  </div>
</div>

<!-- Statistics by Domain -->
<div class="section-row mt-8 mb-8">
  <div class="section-header">
    <h2 class="learner">Statistics by Domain</h2>
  </div>
  <div class="grid-container mt-4">
    <section>
      <h2 class="learner">Top Performing Domains</h2>
      <table class="data-table">
        <thead>
          <tr>
            <th>Domain</th>
            <th>Total Registered Users</th>
            <th>Total Course Registrations</th>
            <th>Total Certificates</th>
          </tr>
        </thead>
        <tbody>
          @for (domain of this.quarterlyReportsStore.topDomainsSignal(); track domain) {
            <tr>
              <td>{{ domain.description1.name }}</td>
              <td>{{ domain.count1.total | number }}</td>
              <td>{{ domain.count2.total | number }}</td>
              <td>{{ domain.count3.total | number }}</td>
            </tr>
          }
        </tbody>
      </table>
      <div class="text-left pl-6 mt-2">
        <a routerLink="/domains" class="primary-link">View Domains</a>
      </div>
    </section>
  </div>
</div>
